import React from 'react';
import { ClipboardList, Factory, ShoppingBag } from 'lucide-react';
import { Heading } from '../layout';
import { TabNavigation } from '../reusable';
import { useUIColors } from '../../hooks/useTheme';
import TcoatProductRequestsPanel from './TcoatProductRequestsPanel';
import UpsellingRequestsPanel from './UpsellingRequestsPanel';

/**
 * Solicitudes comerciales generadas al cerrar cotizaciones como Vendida:
 * productos T-COAT (producción) y upselling (adquisiciones).
 */
const PaintRequestsWorkspace = ({ isDarkMode = false }) => {
  const ui = useUIColors();

  return (
    <div>
      <Heading level={2} isDarkMode={isDarkMode}>
        <ClipboardList size={22} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
        Solicitudes
      </Heading>
      <p style={{ margin: '6px 0 16px', fontSize: '13px', color: ui.muted, maxWidth: '720px' }}>
        Solicitudes a producción (T-COAT) y adquisiciones (upselling). Puedes crear solicitudes manualmente o
        generarlas al cerrar cotizaciones como vendida.
      </p>

      <TabNavigation
        isDarkMode={isDarkMode}
        defaultTab="tcoat"
        tabs={[
          {
            key: 'tcoat',
            label: 'Productos T-COAT',
            icon: <Factory size={16} />,
            content: <TcoatProductRequestsPanel isDarkMode={isDarkMode} />,
          },
          {
            key: 'upselling',
            label: 'Upselling',
            icon: <ShoppingBag size={16} />,
            content: <UpsellingRequestsPanel isDarkMode={isDarkMode} />,
          },
        ]}
      />
    </div>
  );
};

export default PaintRequestsWorkspace;
